import React, { useState } from "react";
import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import { SolutionsFrame } from "components/solutions/SolutionsFrame";

export const ProsumerWaitlist = () => {
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
       alert("Dados enviados com sucesso!");
  };

  return (
    <SolutionsFrame>
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", background: "#fff" }}>
      <Box sx={{ width: "100%", maxWidth: 400, mt: 10, p: 0 }}>
        <Paper elevation={3} sx={{ borderRadius: 4, p: 3, display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, alignSelf: "flex-start" }}>
            Lista de espera
          </Typography>
          <form style={{ width: "100%" }} onSubmit={handleSubmit}>
            <TextField
              label="Telefone"
              placeholder="| digitar telefone"
              variant="outlined"
              fullWidth
              margin="normal"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              InputProps={{ endAdornment: <span role="img" aria-label="edit">✏️</span> }}
            />
            <TextField
              label="E-mail"
              placeholder="| digitar e-mail"
              variant="outlined"
              fullWidth
              margin="normal"
              value={email}
              onChange={e => setEmail(e.target.value)}
              InputProps={{ endAdornment: <span role="img" aria-label="edit">✏️</span> }}
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ mt: 3, borderRadius: 2, background: '#00916E', fontWeight: 'bold', fontSize: 16, py: 1.5 }}
            >
              Salvar e continuar
            </Button>
          </form>
        </Paper>
      </Box>
    </Box>
    </SolutionsFrame>
  );
};

export default ProsumerWaitlist;